import { render, staticRenderFns } from "./workInfo.vue?vue&type=template&id=66d53fcf&scoped=true"
import script from "./workInfo.vue?vue&type=script&lang=js"
export * from "./workInfo.vue?vue&type=script&lang=js"
import style0 from "./workInfo.vue?vue&type=style&index=0&id=66d53fcf&prod&scoped=true&lang=less"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "66d53fcf",
  null
  
)

export default component.exports